import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FuseSharedModule } from '@fuse/shared.module';
import { PhoenixPipesModule } from '../../pipes/pipes';
import { SharedModule } from '../../shared/shared.module';
import { DevExtremeModule } from 'devextreme-angular';
import { DataGridComponent } from './data-grid.component';
import { DateModule } from 'app/main/content/misc/date.module';

@NgModule({
    declarations: [
        DataGridComponent,
    ],
    imports     : [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatTooltipModule,
        FuseSharedModule,
        SharedModule,
        DevExtremeModule,
        PhoenixPipesModule.forRoot(),
        DateModule,
    ],
    exports     : [
        DataGridComponent,
    ],
})
export class DataGridModule
{
}
